import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { GstUpdateFormComponent } from './gst-update-form/gst-update-form.component';
import { MapChargeToBusinessSegmentFormComponent } from './map-charge-to-business-segment-form/map-charge-to-business-segment-form.component';
import { MapChargeToBusinessSegmentRoutingModule } from './map-charge-to-business-segment-routing.module';
import { MapSegmentChargeDetailComponent } from './map-segment-charge-detail/map-segment-charge-detail.component';

@NgModule({
  declarations: [
    MapChargeToBusinessSegmentFormComponent,
    MapSegmentChargeDetailComponent,
    GstUpdateFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MapChargeToBusinessSegmentRoutingModule,
    AngularMaterialModule,
    SharedModule,
    FormsModule, 
  ]
})
export class MapChargeToBusinessSegmentModule { }
